export default {
  modalTitleSoft: "Data Deletion",
  modalMessageSoft: "Are you sure you want to delete this records?",
  modalTitleRestore: "Restore Record",
  modalMessageRestore: "Are you sure you want to restore this record?",
  modalTitlePermanent: "Permanent Deletion",
  modalMessagePermanent: "Are you sure you want to permanently delete this record? This action cannot be undone."
};